import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import MenuIcon from "@mui/icons-material/Menu";
import { Box, Drawer, IconButton } from "@mui/material";
import { useSidebar } from "../../contexts/SidebarContext";
import Menu from "./index";

const DRAWER_OPEN_WIDTH = 260;
const DRAWER_CLOSED_WIDTH = 72;
const HEADER_HEIGHT = 64;

export default function Sidebar() {
  const { open, toggle } = useSidebar();
  const width = open ? DRAWER_OPEN_WIDTH : DRAWER_CLOSED_WIDTH;

  return (
    <Drawer
      variant="permanent"
      sx={{
        width,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width,
          overflowX: "hidden",
          backgroundColor: "var(--blue-200)",
          color: "var(--gray-100)",
          borderRight: 0,
          top: HEADER_HEIGHT,
          height: `calc(100vh - ${HEADER_HEIGHT}px)`,
          transition: (theme) =>
            theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.shorter,
            }),
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: open ? "flex-end" : "center",
          p: 1,
        }}
      >
        <IconButton
          onClick={toggle}
          size="small"
          sx={{ color: "var(--gray-100)" }}
          aria-label={open ? "collapse sidebar" : "expand sidebar"}
        >
          {open ? <ChevronLeftIcon /> : <MenuIcon />}
        </IconButton>
      </Box>
      <Menu collapsed={!open} />
    </Drawer>
  );
}
